export const ROOM_COUNT_SELECTION_HEADING_TEXT = "Rooms & Spaces";

export const ROOM_COUNT_SELECTION_APPLY_BUTTON_LABEL = "Apply";
